import { CapacitorPasskey } from '@capgo/capacitor-passkey';

import { getDomainName } from 'utils/domain';
import { getIsNativePlatform } from 'utils/platform';

/**
 * DEV-4084: install the native WebAuthn shim so passkeys work inside the Capacitor shell.
 *
 * The shell serves the SPA from `capacitor://localhost`, where `navigator.credentials` is not a
 * usable WebAuthn surface and `window.location.hostname` is `localhost`. `@capgo/capacitor-passkey`
 * replaces `navigator.credentials.create/get` with a native implementation (iOS ASAuthorization /
 * Android Credential Manager) and, on iOS 17.4+, encodes the real HTTPS origin into `clientDataJSON`.
 * The origin is the brand's domain (seeded into `lsDomainName` by the mobile build), matching the
 * Associated-Domain the app is bound to and the rpId the ceremony sends to the server. The existing
 * `navigator.credentials` ceremony code then works unchanged.
 *
 * No-op on web (the browser already provides WebAuthn).
 */
export const installNativePasskeyShim = () => {
  if (!getIsNativePlatform()) {
    return;
  }

  CapacitorPasskey.shimWebAuthn({ origin: `https://${getDomainName()}` });
};
